import axios from 'axios';
import api from '../../../utils/api';

export default {
  async follow({}, paylod) {
    const { data } = await axios(api.network.userFollow(paylod));
    return data;
  },
  async fetchFollowers({}, payload) {
    const { data } = await axios(api.network.fetchFollowers(payload));
    return data;
  },
  async unFollowMember({}, deleteUrl) {
    const { data } = await axios(api.network.unFollowMember(deleteUrl));
    return data;
  },
  async unFollowNetwork({}, deleteUrl) {
    const { data } = await axios(api.network.unFollowNetwork(deleteUrl));
    return data;
  },
  async editContactFollowingStatus({}, editData) {
    const { data } = await axios(api.network.editContactFollowingStatus(editData));
    return data;
  },
  async fetchFollowersByTags(_, payload) {
    const { data } = await axios(api.network.fetchFollowersByTags(payload));
    return data.results;
  },
  async searchOnFollowers(_, payload) {
    const { data } = await axios(api.network.searchOnFollowers(payload));
    return data.results;
  },
  async unfollowUserByCustomerId({}, payload) { // eslint-disable-line
    const { data } = await axios(api.network.unfollowUserByCustomerId(payload));
    return data;
  }
};
